export const testimonials = [
    {
        image: require('../../assets/images/TestimonialImages/Riddhi.png'),
        content: `Yogita ma’am, I want to let you know how grateful I am for all that you have
        taught me. Till this day, I am so clear on all my concepts. I cannot stress this
        enough ma’am, but all the knowledge that you have imparted still helps me in
        the present. When I see students today struggling with coding in college, I
        always think of you and cannot help but feel grateful that I got to study under
        your guidance. I hope I get to be your student again once.`,
        name: `Riddhi`,
        designation: ""
    },
    
    {
        image: require('../../assets/images/TestimonialImages/Shanvi.png'),
        content: `Yogita ma’am has a unique style of teaching computers to students. She is focused, friendly, understanding and takes responsibility of each student
        associated with her. I remember her giving me a chocolate before my computer exam. It mattered to me. Sometimes, motivation and trust is all we
        students need from a teacher.`,
        name: `Shaanvi`,
        designation: ``
    },
     
    {
        image: require('../../assets/images/TestimonialImages/AdityaGoyal.png'),
        content: `Yogita Ma’am is a gem of a teacher. I was her student in high school,
        and her teaching style of Computer Science was truly transformative.
        She broke down complex concepts into bite-sized pieces, which made
        learning easy and fun. Her wealth of knowledge in the field was evident
        from the way she answered all complex questions. She was a firm
        believer that there are no bad questions. We had the comfort of
        clarifying all our doubts, which helped us during exams. I give her huge
        credit for helping me get a 100% in both 10th and 12th grades. Along
        with high school Computer Science, I took the Advanced Placement
        (AP) CS A exam to strengthen my college application, and she was the
        one I could count on; she is the reason why I achieved a perfect score
        on the test. Looking back, she had a profound impact on my journey to
        become a professional Computer Scientist and secure offers from IBM
        and Nvidia. I highly recommend her.`,
        name: `Aditya Goyal `,
        designation: ``
    },
    {
        image: require('../../assets/images/TestimonialImages/Udayveer.png'),
        content: `I first got the opportunity to get tutored by Yogita mam when I was in
        10th grade. I was really bad at computer science and used to barely
        pass my exams. Yogita ma’am taught me right from scratch, helped me
        build my basics and made sure that not only did I ace my exams but
        also understood every concept in depth. It is all because of her
        constant efforts that I was able to secure 99/100 in computer science in
        both grade 10 ICSE and 12 ISC board exams. She was always there
        when we needed her, even on the nights before the board
        examinations, giving each student personal attention. If you wish to
        grasp the nuances of computer science and ace your exams, she is the
        one who can make it happen!`,
        name: `Udayveer Mittal `,
        designation: ``
    },
    
    {
        image: require('../../assets/images/TestimonialImages/Kavya.png'),

        content: `When Yogita ma’am started teaching me computers, I absolutely fell in
        love with the subject. She made progamming so interesting and easy!
        Computers is a subject where we need guidance, intellect and interest
        and ma’am helped every student develop these skills. Aside from the
        academics, she is warm and friendly, and creates a positive
        environment for us to learn in. In all, if you want to become skilled and
        a pro at solving every kind of programme, then Yogita ma’am is the go-
        to person for that! Always thankful and grateful to her.`,
        name: `Kavya `,
        designation: ``
    },
   
    {
        image: require('../../assets/images/TestimonialImages/Saniya.png'),

        content: `I have studied with yogita maam from 2013 to 2016. The experience has been so wholesome. I have not opened a book after my tution class ever. The only computer I did at home was some excercise maam used to give. That is it. Those 2 hours with her were enough for me to understand and retain knowledge. I scored 100 in both 10th and 12th in SJA, all because of her. The tricks she used to give helped me remember tough programs. Now that i look back after almost 10 years, it has somewhere helped me with my problem solving skills. They got developed at a very basic level with maam. 

        I would not have scored 100% if it was not for maam!
        `,
        name: `Saniya`,
        designation: ``
    },
    {
        image: require('../../assets/images/TestimonialImages/Vanshika.png'),

        content: `I'm writing to express my sincere gratitude to Yogita Ma’am who has taught me computers from Class 10th to 12th. Her exceptional teaching style and dedication to her students have had a profound impact on my life.
        Mam's way of explaining the trickiest concepts in a clear and concise way made computer an engaging and enjoyable subject for me.No matter how complex the topic would be,mam would break it down into simpler steps and relatable examples.Ma'am created a comfortable learning environment in her classes.I never felt hesitant to ask questions or clear any doubts.
        I had the privilege of learning from her and undoubtedly computers went from a mysterious subject to one of my favorites.Ma'am made computer learning fun, effective, and long-lasting.
        The skills and knowledge I gained in her classes have given me a significant advantage even when I'm persuing Bachelors of Computer Applications.
        Mam's ability to connect with students is truly commendable and her exceptional teaching methods make her an outstanding educator.
        I cannot thank mam enough for how much she has helped me all through the years as a mentor and the best teacher ever.`,
        name: `Vanshika`,
        designation: ``
    },
    {
        image: require('../../assets/images/TestimonialImages/SakshamDua.png'),
        content: `I had been a student of Yogita maam for 3 years.When I came to maam i was struggling in computer’s but the way maam taught all of us,we all just aimed for full in exams.Our classes were fun,we used to get breaks in between-the best part maam rarely scolded us for being late😬😬we used to say “maam never gets angry”….She not only just taught us computer’s as a subject but as a hobby which we can enjoy that’s why we never bunked maam’s class…
        During our exams maam used to plan extra classes…we  used to sit for about 6-8 hrs a day or even more…From putting individual attention in everyone to motivating us all maam build the subject in us in a fun and friendly environment.I became the favourite student of maam
        from our batch because I used to trouble maam a lot😂😂…..
        At last I want to thank maam for not letting computer’s subject a burden for us,We all made lots of memories and enjoyed our learning.
        `,
        name: `Saksham Dua`,
        designation: ``
    },
    {
        image: require('../../assets/images/TestimonialImages/Keya.png'),
        content: `Yogita ma’am, is by far the best computer science teacher you can find in the whole of Dehradun. It is because of her efforts, the way she converts complicated questions into easy to understand concepts, that I was able to score a 100 on my class 10 ICSE Board Examinations. Yogita ma’am is known for her mnemonics, memorisation techniques, systematic notes, and her easy-going nature. She is able to engage every student in the class while also maintaining discipline. 
        Thank you so much ma’am.`,
        name: `Keya`,
        designation: ``
    },
]